
























import { Vue, Component, Prop, Mixins } from 'vue-property-decorator';
import { Constants } from '@/constants/constants';
import { statisticsModule } from '@/store/modules/frames/statistics.module';
import GCompetencyLabel from '@/components/GCompetencyLabel.vue';
import GCustomBreadCrumb from '@/components/GCustomBreadCrumb.vue';
import GLoading from '@/components/GLoading.vue';
import { GPageBase } from '@/mixins';
import { StatisticsCompetencyGrowthEchartService } from '@/service/echart/statistics-competency-growth.echart.service';
import { Competency } from '@/models/competency/competency';

@Component({
  name: 'GStatisticsAllCompetencyGrowthChart',
  components: { GLoading, GCustomBreadCrumb, GCompetencyLabel },
  computed: {},
  methods: {},
})
export default class GStatisticsAllCompetencyGrowthChart extends Mixins(GPageBase) {
  studentID: number = 0;
  competencyGrowthCharts: StatisticsCompetencyGrowthEchartService[] = [];
  readonly CHART_HEIGHT = 240;
  // boxplotSubTableData
  @Prop({ default: null }) boxplotSubTableData: any[];

  get options(): any {
    this.conversionFanchart();
    return statisticsModule.echartService.options;
  }

  conversionFanchart() {
    statisticsModule.echartService.options.forEach((option: any, key: number) => {
      option.series.map((s: any) => {
        let firstScore: number = 0;
        if (s.data.length > 0) firstScore = s.data[0];
        s.data = s.data.map((d: any) => {
          const score = Math.floor((d / firstScore) * 100 * 10) / 10;
          return score;
        });
      });
    });
  }

  get competencyIDs(): number[] {
    return statisticsModule.echartService.options.keys();
  }

  get competencyNameByMap(): Map<number, string> {
    return new Map(statisticsModule.competencyByType.map((c: Competency) => [c.competencyID, c.name]));
  }
}
